<template>
    <el-card>
        <el-row class="report__title">游戏房分成配置</el-row>
        <!-- 搜索 -->
        <el-row class="report__search">
            <div class="item">
                <span>选择周：</span>
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleDateRangeChange">
                </el-date-picker>
            </div>
            <div class="item">
                <el-button type="primary" @click="getCurrentWeekData">查询当前周</el-button>
                <el-button type="success" @click="editNextWeek">编辑下周</el-button>
            </div>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="tableList">
                <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
                <el-table-column prop="level" label="等级" align="center" width="100"></el-table-column>
                <el-table-column prop="betCoins" label="房间下注金币数" align="center" width="150"></el-table-column>
                <el-table-column prop="activePlayer" label="有效玩家人数" align="center" width="150"></el-table-column>
                <el-table-column prop="assistant" label="可拥有助理人数" align="center" width="150"></el-table-column>
                <el-table-column prop="ownerReward" label="房主奖励" align="center" width="150"></el-table-column>
                <el-table-column prop="assistantReward" label="助理奖励" align="center" width="150"></el-table-column>
                <el-table-column prop="totalReward" label="总奖励" align="center" width="150">
                    <template slot-scope="scope">
                        {{ calculateTotalReward(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="startAt" label="生效开始时间" align="center" width="180">
                    <template slot-scope="scope">
                        {{ formatTimestamp(scope.row.startAt) }}
                    </template>
                </el-table-column>
                <el-table-column prop="endAt" label="生效结束时间" align="center" width="180">
                    <template slot-scope="scope">
                        {{ formatTimestamp(scope.row.endAt) }}
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
            </el-table>
        </el-row>
        <!-- 编辑下周配置弹窗 -->
        <el-dialog
            title="编辑下周配置"
            :visible.sync="editDialogVisible"
            width="90%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="editDialogClose"
            class="edit-dialog"
        >
            <div class="dialog-header">
                <div class="header-info">
                    <i class="el-icon-edit"></i>
                    <span>配置管理</span>
                </div>
                <div class="header-actions">
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddConfig">添加配置</el-button>
                    <el-button type="success" icon="el-icon-check" @click="handleSaveAll">保存所有</el-button>
                    <el-button icon="el-icon-close" @click="editDialogClose">取消</el-button>
                </div>
            </div>
            <div class="table-container">
                <el-table 
                    :data="editTableList" 
                    class="edit-table"
                    :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                    :cell-style="{ padding: '8px 0' }"
                    stripe
                    border
                >
                    <el-table-column prop="level" label="等级" align="center" width="100">
                        <template slot-scope="scope">
                            <el-input-number 
                                v-model="scope.row.level" 
                                :min="1" 
                                :max="999" 
                                size="small"
                                controls-position="right"
                                class="input-number"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="betCoins" label="房间下注金币数" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input 
                                v-model="scope.row.betCoins" 
                                size="small" 
                                placeholder="请输入金币数"
                                class="input-field"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activePlayer" label="有效玩家人数" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input-number 
                                v-model="scope.row.activePlayer" 
                                :min="0" 
                                :max="9999" 
                                size="small"
                                controls-position="right"
                                class="input-number"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="assistant" label="可拥有助理人数" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input-number 
                                v-model="scope.row.assistant" 
                                :min="0" 
                                :max="999" 
                                size="small"
                                controls-position="right"
                                class="input-number"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ownerReward" label="房主奖励" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input 
                                v-model="scope.row.ownerReward" 
                                size="small" 
                                placeholder="请输入房主奖励"
                                class="input-field"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="assistantReward" label="助理奖励" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input 
                                v-model="scope.row.assistantReward" 
                                size="small" 
                                placeholder="请输入助理奖励"
                                class="input-field"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalReward" label="总奖励" align="center" width="160">
                        <template slot-scope="scope">
                            <el-input 
                                :value="calculateTotalReward(scope.row)" 
                                size="small" 
                                disabled
                                class="input-field"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startAt" label="生效开始时间" align="center" width="200">
                        <template slot-scope="scope">
                            <el-date-picker
                                v-model="scope.row.startAt"
                                type="datetime"
                                placeholder="选择开始时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="timestamp"
                                :timestamp="true"
                                size="small"
                                class="date-picker"
                                disabled
                                @change="handleTimeChange(scope.row, 'startAt', $event)"
                            ></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endAt" label="生效结束时间" align="center" width="200">
                        <template slot-scope="scope">
                            <el-date-picker
                                v-model="scope.row.endAt"
                                type="datetime"
                                placeholder="选择结束时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="timestamp"
                                :timestamp="true"
                                size="small"
                                class="date-picker"
                                disabled
                                @change="handleTimeChange(scope.row, 'endAt', $event)"
                            ></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button 
                                type="danger" 
                                icon="el-icon-delete" 
                                size="small" 
                                @click="handleDeleteConfig(scope.$index)"
                                class="delete-btn"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

    </el-card>
</template>

<script>
export default {
    data() {
        return {
            tableList: [],
            dateRange: null,
            editDialogVisible: false,
            editTableList: [],
            nextWeekStartTime: null,
            nextWeekEndTime: null
        }
    },
    created() {
        this.getCurrentWeekData()
    },
    methods: {
        // 计算总奖励：助理奖励*可拥有助理人数+房主奖励
        calculateTotalReward(row) {
            const assistantReward = parseFloat(row.assistantReward) || 0
            const assistant = parseInt(row.assistant) || 0
            const ownerReward = parseFloat(row.ownerReward) || 0
            return (assistantReward * assistant + ownerReward).toFixed(2)
        },

        // 格式化秒时间戳为可读的日期时间格式
        formatTimestamp(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp * 1000)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        },

        // UTC+8时区工具函数
        getUTCP8Time() {
            const now = new Date()
            const utc8Time = new Date(now.getTime() + (8 * 60 * 60 * 1000))
            return utc8Time
        },

        // 格式化UTC+8日期为YYYY-MM-DD
        formatUTCP8Date(date) {
            const utc8Date = new Date(date.getTime() + (8 * 60 * 60 * 1000))
            return utc8Date.toISOString().split('T')[0]
        },

        // 日期范围选择变化
        handleDateRangeChange(dateRange) {
            if (dateRange && dateRange.length === 2) {
                this.getDateRangeData(dateRange[0], dateRange[1])
            } else {
                this.tableList = []
            }
        },

        // 获取当前周数据
        async getCurrentWeekData() {
            const now = this.getUTCP8Time()
            const currentWeekStr = this.getWeekStartDate(now)
            const currentWeek = new Date(currentWeekStr + 'T00:00:00+08:00')
            // 结束时间改为下一周周一0点
            const nextWeekStart = new Date(currentWeek.getTime() + 7 * 24 * 60 * 60 * 1000)
            this.dateRange = [currentWeekStr, this.formatUTCP8Date(nextWeekStart)]
            await this.getDateRangeData(currentWeekStr, this.formatUTCP8Date(nextWeekStart))
        },

        // 获取日期范围数据
        async getDateRangeData(startDate, endDate) {
            // 确保使用UTC+8时区进行时间戳转换
            const startTime = Math.floor(new Date(startDate + 'T00:00:00+08:00').getTime() / 1000)
            // 结束时间改为下一周周一0点，而不是23:59:59
            const endTime = Math.floor(new Date(endDate + 'T00:00:00+08:00').getTime() / 1000)

            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.game_room_reward_config_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    startTime: startTime,
                    endTime: endTime,
                },
            })
            
            if (res.code === 0 || res.status === 0) {
                this.tableList = res.data || []
            } else {
                this.$message.error(res.msg || res.message)
            }
        },


        // 编辑下周
        async editNextWeek() {
            const now = this.getUTCP8Time()
            const nextWeekStart = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
            const nextWeekStartDate = this.getWeekStartDate(nextWeekStart)
            
            this.nextWeekStartTime = Math.floor(new Date(nextWeekStartDate + 'T00:00:00+08:00').getTime() / 1000)
            this.nextWeekEndTime = this.nextWeekStartTime + 7 * 24 * 60 * 60

            // 查询下周数据
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.game_room_reward_config_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    startTime: this.nextWeekStartTime,
                    endTime: this.nextWeekEndTime,
                },
            })

            if (res.code === 0 || res.status === 0) {
                if (res.data && res.data.length > 0) {
                    // 有数据，直接编辑
                    this.editTableList = res.data.map(item => ({
                        ...item,
                        startAt: item.startAt ? item.startAt * 1000 : null,
                        endAt: item.endAt ? item.endAt * 1000 : null
                    }))
                } else {
                    // 无数据，初始化下周配置
                    await this.initNextWeekConfig()
                }
                this.editDialogVisible = true
            } else {
                this.$message.error(res.msg || res.message)
            }
        },

        // 初始化下周配置
        async initNextWeekConfig() {
            try {
                const { data: res } = await this.$axios({
                    method: 'get',
                    url: this.$store.getters.path.game_room_reward_config_copy,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.editTableList = (res.data || []).map(item => ({
                        ...item,
                        startAt: item.startAt ? item.startAt * 1000 : null,
                        endAt: item.endAt ? item.endAt * 1000 : null
                    }))
                    this.$message.success('已初始化下周配置')
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                console.error('初始化失败:', error)
                this.$message.error('初始化失败')
            }
        },

        // 获取周开始日期（周一）- 使用UTC+8时区
        getWeekStartDate(date) {
            const d = new Date(date)
            const day = d.getDay()
            const diff = d.getDate() - day + (day === 0 ? -6 : 1) // 调整到周一
            const weekStart = new Date(d.setDate(diff))
            // 确保返回UTC+8时区的日期
            return this.formatUTCP8Date(weekStart)
        },

        // 时间变化处理
        handleTimeChange(row, field, value) {
            if (value) {
                row[field] = Math.floor(new Date(value).getTime() / 1000)
            } else {
                row[field] = 0
            }
        },

        // 添加配置
        handleAddConfig() {
            // 获取最后一条数据的等级，如果没有数据则默认为0
            const lastLevel = this.editTableList.length > 0 
                ? (this.editTableList[this.editTableList.length - 1].level || 0)
                : 0
            
            const newConfig = {
                id: null,
                level: lastLevel + 1,
                betCoins: '',
                activePlayer: 0,
                assistant: 0,
                ownerReward: '',
                assistantReward: '',
                totalReward: '',
                startAt: this.nextWeekStartTime * 1000,
                endAt: this.nextWeekEndTime * 1000,
                ctime: 0,
                mtime: 0,
                operator: this.$store.getters.username
            }
            this.editTableList.push(newConfig)
        },

        // 删除配置
        handleDeleteConfig(index) {
            this.$confirm('确定要删除这条配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.editTableList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 保存所有配置
        async handleSaveAll() {
            try {
                const configList = this.editTableList.map(item => ({
                    id: item.id,
                    level: parseInt(item.level) || 0,
                    betCoins: item.betCoins || '',
                    activePlayer: parseInt(item.activePlayer) || 0,
                    assistant: parseInt(item.assistant) || 0,
                    ownerReward: item.ownerReward || '',
                    assistantReward: item.assistantReward || '',
                    totalReward: this.calculateTotalReward(item),
                    startAt: item.startAt ? Math.floor(item.startAt / 1000) : this.nextWeekStartTime,
                    endAt: item.endAt ? Math.floor(item.endAt / 1000) : this.nextWeekEndTime,
                    ctime: item.ctime || 0,
                    mtime: item.mtime || 0,
                    operator: this.$store.getters.username
                }))

                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.game_room_reward_config_batch_submit,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        configList: configList
                    }
                })

                if (res.code === 0 || res.status === 0) {
                    this.$message.success('保存成功')
                    this.editDialogVisible = false
                    this.getCurrentWeekData() // 刷新当前周数据
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                console.error('保存失败:', error)
                this.$message.error('保存失败')
            }
        },

        // 编辑弹窗关闭
        editDialogClose() {
            this.editDialogVisible = false
            this.editTableList = []
        }
    },
}
</script>

<style scoped lang="scss">
.report {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    :deep(.el-button) {
        width: 80px;
        margin-left: 0;
    }
}

.drawer-footer {
    text-align: right;
    padding: 20px;
    border-top: 1px solid #e4e7ed;
}

:deep(.el-drawer__body) {
    padding: 20px;
}

:deep(.el-form-item__label) {
    font-weight: 600;
}
</style>
